export default "__VITE_ASSET__0e25a2e6__"